import { React, ReactRouter, useAPI } from 'mcelroy-lib'
import { FormPage, useToast, useUserContext } from 'mcelroy-components'
import { useTurnstile } from '../util/Turnstile'
import { useQuery } from '../util/useQuery'


/*
    Page to reset passwords when forgotten
*/
export function ResetPasswordPage() {
    // The old Tapestry way passed multiple server parameters (sp) in the url query
    // The first one (index 0) is the reset password token from the email
    const query = useQuery()
    let token = query['sp']?.[0]

    if (token != null) {
        if (token[0] === 'S') // Tapestry service parameters were prepended with an S
            token = token.substring(1)
        return <ResetPassword token={token} />
    } else {
        return <SendResetPassword />
    }
}


export function SendResetPassword() {
    const { wrapperRef, turnstile } = useTurnstile()
    const navigate = ReactRouter.useNavigate()
    const { user } = useUserContext()
    const toast = useToast()
    const {run: sendPasswordReset} = useAPI(`
        mutation sendPasswordReset($email: String!, $turnstile: String){
            sendPasswordReset(email: $email, turnstile: $turnstile)
        }
    `)

    const fields = [
        { label: "Email", value: "", name: "email" }
    ]

    const buttons = [
        {
            label: 'Submit',
            primary: true,
            onClick: async function (formData) {
                try{
                    const token = await turnstile.current.getToken(user?.internal)
                    await sendPasswordReset({ email: formData.email, turnstile: token })
                    toast.success('Reset password email sent')
                    navigate('/')
                }catch(err) {
                    toast.error(err[0]?.message ?? 'Error sending reset email.  Contact support.')
                    console.log(err)
                    turnstile.current.reset()
                }
            }
        }
    ]

    return (
        <div>
            <FormPage pageTitle="Account" title="Request Password Reset" fields={fields} buttons={buttons}>
                <div ref={wrapperRef} style={{ marginTop: '20px' }}></div>
            </FormPage>  
        </div>
    )
}


export function ResetPassword({token}) {
    const navigate = ReactRouter.useNavigate()
    const toast = useToast()
    const {run: resetPassword} = useAPI(`
        mutation resetPassword($token: String!, $password: String!){
            resetPassword(token: $token, password: $password)
        }
    `)

    const fields = [
        { label: "New Password", value: "", name: "password", type: 'password' },
        { label: "New Password Again", value: "", name: "passwordAgain", type: 'password' }
    ]

    const buttons = [
        {
            label: 'Update',
            primary: true,
            onClick: async function (formData) {
                try {
                    if (formData.password != formData.passwordAgain) {
                        toast.error('Passwords do not match.')
                        return
                    }
                    await resetPassword({ token: token, password: formData.password })
                    toast.success('Password reset -- please log in')
                    navigate('/')
                }catch(err) {
                    toast.error(err[0]?.message ?? 'Error sending reset email.  Contact support.')
                    console.log(err)
                }
            }
        }
    ]

    return (
        <div>
            <FormPage pageTitle="Account" title="Reset Password" fields={fields} buttons={buttons}>
            </FormPage>
        </div>
    )
}
